































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Cutoverplan } from '@/types';
import axios from 'axios';
import env from '@/env';

@Component({})
export default class DeleteCutoverplanDialog extends Vue {
  @Prop()
  cutoverplan!: Cutoverplan;

  @Prop()
  vOn?: any;

  dialog = false;

  async deleteCutoverplan() {
    await axios.delete(`${env.backend_url}/cutoverplan/${this.cutoverplan.id}`);
    this.$router.push({ path: '/' });
  }
}
